import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TypeStateData {
  typeSlice: {
    values: string;
  };
}
export interface TypeState {
  values: string;
}

const initialState: TypeState = {
  values: '/interactives',
};

const typeSlice = createSlice({
  name: 'type',
  initialState,
  reducers: {
    setInteractiveType: (state, action: PayloadAction<string>) => {
      state.values = action.payload;
    },
  },
});

export const { setInteractiveType } = typeSlice.actions;
export default typeSlice.reducer;
